"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesSectionTitle = void 0;
var styled_components_1 = require("styled-components");
exports.StylesSectionTitle = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .sds-reset-style .sds-section-title {\n    flex-direction: row;\n    align-items: center;\n    .section-content {\n      height: 10px;\n      width: 40px;\n      border-radius: 40px;\n      margin-right: 15px;\n      background-color: ", ";\n    }\n  }\n"], ["\n  .sds-reset-style .sds-section-title {\n    flex-direction: row;\n    align-items: center;\n    .section-content {\n      height: 10px;\n      width: 40px;\n      border-radius: 40px;\n      margin-right: 15px;\n      background-color: ",
    ";\n    }\n  }\n"])), function (props) {
    return props.theme.colors.primaryLightThin;
});
var templateObject_1;
